var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserFollowFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.666 18.7493V29.3333H5.66602C5.66587 27.8199 5.98779 26.3238 6.61037 24.9443C7.23295 23.5649 8.14195 22.3337 9.27697 21.3326C10.412 20.3316 11.747 19.5835 13.1934 19.1381C14.6398 18.6926 16.1645 18.5601 17.666 18.7493ZM16.3327 17.3333C11.9127 17.3333 8.33268 13.7533 8.33268 9.33331C8.33268 4.91331 11.9127 1.33331 16.3327 1.33331C20.7527 1.33331 24.3327 4.91331 24.3327 9.33331C24.3327 13.7533 20.7527 17.3333 16.3327 17.3333ZM24.0567 26.552L28.77 21.8386L30.6567 23.724L24.0567 30.324L19.342 25.6093L21.2287 23.724L24.0553 26.552H24.0567Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFollowFill);
export default __webpack_public_path__ + "static/media/user-follow-fill.845b0abd1e0b5aa80a3ff203fd1b5aab.svg";
export { ForwardRef as ReactComponent };